import { RootState } from "../../../../../redux/store";

export const vehicleCategoriesLoading = (state: RootState) => state.vehicleCategories.itemsLoading;
export const vehicleCategoryActionLoading = (state: RootState) => state.vehicleCategories.actionsLoading;
export const dropDownLoading = (state: RootState) => state.vehicleCategories.dropDownLoading;

export const vehicleCategories = (state: RootState) => state.vehicleCategories.items;
export const vehicleCategoriesCount = (state: RootState) => state.vehicleCategories.itemsCount;
export const vehicleCategoryForEdit = (state: RootState) => state.vehicleCategories.itemForEdit;
export const dropDownValues = (state: RootState) => state.vehicleCategories.dropDownItems;

export const error = (state: RootState) => state.vehicleCategories.error;
export const errorAction = (state: RootState) => state.vehicleCategories.errorAction;
export const dropDownError = (state: RootState) => state.vehicleCategories.dropDownError;

export const validationErrors = (state: RootState) => state.vehicleCategories.validationErrors;

export const filters = (state: RootState) => state.vehicleCategories.filters;
